export const translation = {};
